
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.28 16.325h2.062v-2.062H2.281zM8.753 1.78H9.85V0H8.753zM0 8.827v1.097h8.753v2.784H9.85V8.827zM0 6.62h6.62V0H0v6.62zm1.098-1.097h4.424V1.098H1.098v4.425zM8.754 6.62H9.85V2.945H8.754z"}}),_c('path',{attrs:{"d":"M2.28 4.34h2.06V2.28H2.28zm10.688 4.413h-1.097v6.085H8.233v1.097h4.735zM0 18.603h6.62v-6.62H0v6.62zm1.098-1.097h4.424v-4.425H1.098v4.425zm16.407-7.202h1.098v-1.55h-1.098zM14.263 4.34h2.061V2.28h-2.061z"}}),_c('path',{attrs:{"d":"M11.984 6.62h6.62V0h-6.62v6.62zm1.099-1.097h4.424V1.098h-4.424v4.425zm-2.477 13.08h2.363v-1.097h-2.363zm4.238-2.668h1.098V8.753h-1.098z"}}),_c('path',{attrs:{"d":"M17.505 13.13v4.375h-2.852v1.099h3.95v-5.475z"}})])])
          )
        }
      }
    